import { careEnvironmentSelectionsForSetting } from './careSettings';

type AdjustableInference = 'careHoursMultiplier' | 'familyCareShare';

export interface CareScenarioChange {
  careSetting?: ConsumerCareSetting;
  /** null returns to the predicted care hours. */
  careHoursMultiplier?: number | null;
  /** null returns to the family's predicted hours. */
  familyCareShare?: number | null;
}

function withCustomInference(
  inferences: ClientCustomInferences,
  key: AdjustableInference,
  value: number | null | undefined,
): ClientCustomInferences {
  if (value === undefined) return inferences;
  const { [key]: _previous, ...rest } = inferences;
  return value === null ? rest : { ...rest, [key]: value };
}

/** The client with one or more care assumptions changed, ready to re-derive and preview. */
export function withCareScenarioChange(client: Client, change: CareScenarioChange): Client {
  const changesInferences = change.careHoursMultiplier !== undefined || change.familyCareShare !== undefined;

  return {
    ...client,
    ...(change.careSetting && {
      careEnvironmentSelections: careEnvironmentSelectionsForSetting(change.careSetting),
    }),
    ...(changesInferences && {
      clientCustomInferences: withCustomInference(
        withCustomInference(client.clientCustomInferences ?? {}, 'careHoursMultiplier', change.careHoursMultiplier),
        'familyCareShare',
        change.familyCareShare,
      ),
    }),
  };
}
